import Backbone from 'backbone';
import AdminConstants from 'constants/AdminConstants';
import { EventEmitter } from 'events';
// Include utils to react to fetch market actions
import assign from 'object-assign';
import i18next from 'i18next';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import ToastStore from 'stores/ToastStore';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'MARKETS_CHANGE';
let loading = false;
let markets = [];
let market = null;
let marketError = null;
const MarketsStore = assign({}, EventEmitter.prototype, {
    emitChange(payload) {
        this.emit(CHANGE_EVENT, payload);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    find(id) {
        if (!markets)
            return false;
        let found = false;
        let i = 0;
        while (!found && i < markets.length) {
            if (markets[i]._id === id)
                found = markets[i];
            i += 1;
        }
        return found;
    },
    findByCode(code) {
        if (!markets) {
            return null;
        }
        const market = markets.find((m) => m.code === code);
        return market;
    },
    getMarket() {
        return market;
    },
    getMarketError() {
        return marketError;
    },
    getMarkets() {
        return markets;
    },
    onMarketsFetch() {
        loading = true;
        markets = false;
        this.emitChange();
    },
    receiveMarkets(payload) {
        loading = false;
        markets = payload.markets;
        this.emitChange();
    },
    receiveMarket(payload) {
        // Checking to see if market currently exists in store, if not add it.
        let found = false;
        const updatedMarkets = markets.map((x) => {
            if (x.id === payload.market.id) {
                found = true;
                return payload.market;
            }
            return x;
        });
        if (!found) {
            updatedMarkets.push(payload.market);
        }
        markets = updatedMarkets;
        loading = false;
        this.emitChange();
    },
    onCreateMarketSuccess(payload) {
        markets.push(payload.market);
        toast(i18next.t('MARKET_CREATE_SUCCESS'), 'success');
        loading = false;
        this.emitChange();
    },
    onUpdateMarketSuccess(payload) {
        let found = false;
        const updatedMarkets = markets.map((x) => {
            if (x.id === payload.market.id) {
                found = true;
                return payload.market;
            }
            return x;
        });
        toast(i18next.t('MARKET_SUCCESSFULLY_UPDATED'), 'success');
        if (!found) {
            updatedMarkets.push(payload.market);
        }
        markets = updatedMarkets;
        loading = false;
        this.emitChange();
    },
    onCreateMarketError() {
        toast(i18next.t('MARKET_CREATE_ERROR'), 'error');
        this.emitChange();
    },
    onUpdateMarketError() {
        toast(i18next.t('MARKET_UPDATE_ERROR'), 'error');
        this.emitChange();
    },
    onFindMarketSuccess(payload) {
        market = payload.market;
        marketError = null;
        loading = false;
        this.emitChange();
    },
    onFindMarketFail(payload) {
        marketError = payload.error;
        market = null;
        loading = false;
        this.emitChange();
    },
});
function toast(message, level) {
    if (!level)
        level = 'error';
    ToastStore.getNotifications().push({
        title: message,
        body: '',
        level: level,
    });
    ToastStore.emitChange();
}
// Register action handlers
MarketsStore.dispatchToken = AdminAppDispatcher.register((payload) => {
    const action = payload.action;
    const { data } = action;
    switch (action.type) {
        case ActionTypes.MARKETS_FETCH:
            MarketsStore.onMarketsFetch();
            break;
        case ActionTypes.RECEIVE_MARKETS:
            MarketsStore.receiveMarkets(action);
            break;
        case ActionTypes.RECEIVE_MARKET:
            MarketsStore.receiveMarket(action);
            break;
        case ActionTypes.CREATE_MARKET_SUCCESS:
            MarketsStore.onCreateMarketSuccess(action);
            break;
        case ActionTypes.UPDATE_MARKET_SUCCESS:
            MarketsStore.onUpdateMarketSuccess(action);
            break;
        case ActionTypes.CREATE_MARKET_ERROR:
            MarketsStore.onCreateMarketError();
            break;
        case ActionTypes.UPDATE_MARKET_ERROR:
            MarketsStore.onUpdateMarketError();
            break;
        case ActionTypes.FIND_MARKET_SUCCESS:
            MarketsStore.onFindMarketSuccess(action);
            break;
        case ActionTypes.FIND_MARKET_FAIL:
            MarketsStore.onFindMarketFail(action);
            break;
        default:
    }
});
export default MarketsStore;
